import ReactJson from 'react-json-view';
import { useCallback, useContext, useMemo } from 'react';
import { UserContext } from '../../Contexts/UserContext';
import { ACCESS_CONTROL_CONSTANTS } from '../../core/constants';
const { SYSTEMS, UI_ACCESS, TYPES } = ACCESS_CONTROL_CONSTANTS;

const UpdateReactJson = ({
	keyData,
	object,
	updateObject,
	allowOnlyString,
	system = SYSTEMS.FRAMERATE
}) => {
	const { getAccessControlSet } = useContext(UserContext);
	/**
	 * This variable contains a set of strings that signifies if this input is either visible/disabled/hidden
	 * @type {Set<string>}
	 */
	const reactJsonControlledAccessSet = useMemo(() => {
		return getAccessControlSet(system, TYPES.INPUT_NAMES, keyData);
	}, [getAccessControlSet, keyData, system]);

	/**
	 * Updates the raw Json object during edit functionality
	 * @param edit - The object returned from ReactJson Component after edit.
	 */
	const handleJsonEdit = useCallback(
		(edit) => {
			const updatedJson = edit?.updated_src;
			if (allowOnlyString) {
				if (typeof edit.new_value === 'string') {
					// Allow the edit if the value is a string
					updateObject((obj) => {
						return { ...obj, [keyData]: updatedJson };
					});
					return true;
				} else {
					// Cancel the edit if the value is not a string
					alert('Enter only string value');
					return false;
				}
			} else {
				updateObject((obj) => {
					return { ...obj, [keyData]: updatedJson };
				});
			}
		},
		[allowOnlyString, keyData, updateObject]
	);

	/**
	 * Updates the raw Json object during add functionality
	 * @param add - The object returned from ReactJson Component after add.
	 */
	const handleJsonAdd = useCallback(
		(add) => {
			const updatedJson = add?.updated_src;
			updateObject((obj) => {
				return { ...obj, [keyData]: updatedJson };
			});
		},
		[keyData, updateObject]
	);

	/**
	 * Updates the raw Json object during delete functionality
	 * @param del - The object returned from ReactJson Component after delete.
	 */
	const handleJsonDelete = useCallback(
		(del) => {
			const updatedJson = del?.updated_src;
			updateObject((obj) => {
				return { ...obj, [keyData]: updatedJson };
			});
		},
		[keyData, updateObject]
	);

	/**
	 * If the user has access to edit the JSON object, then the functionalities are enabled.
	 */
	const accessFunctionalities = useMemo(() => {
		if (reactJsonControlledAccessSet.has(UI_ACCESS.DISABLE)) {
			return {};
		}
		return {
			onDelete: handleJsonDelete,
			onAdd: handleJsonAdd,
			onEdit: handleJsonEdit
		};
	}, [reactJsonControlledAccessSet, handleJsonAdd, handleJsonDelete, handleJsonEdit]);

	return (
		<>
			{!reactJsonControlledAccessSet.has(UI_ACCESS.HIDE) && (
				<ReactJson
					name={false}
					enableClipboard={true}
					displayDataTypes={false}
					{...accessFunctionalities}
					src={object[keyData] && typeof object[keyData] === 'object' ? object[keyData] : {}}
				/>
			)}
		</>
	);
};
export default UpdateReactJson;
